import { useSelector } from "react-redux";

/**
 * redux/cartCount.js
 * ONE count of what the shopper has in their carts, for the header badge and
 * the cart hub alike. Lusuku keeps one cart per vendor (in-house, each shop,
 * each brand, each restaurant, each pharmacy), and the badge that opens the
 * cart hub counts every one of them, the way the hub lists every one of them.
 * The count is of lines (distinct items), as the hub shows them.
 */

/** The vendor slices that keep one cart per vendor, by cart key. */
const VENDOR_CART_SLICES = ["retailerWholesalerCart", "brandCart", "restaurantCart", "healthcareCart"];

/**
 * The carts of one vendor slice that hold something, as [{ key, items }].
 * A key left behind by a missing vendor id ("null", "undefined") is no cart.
 */
export const filledVendorCarts = (carts) =>
  Object.entries(carts || {})
    .filter(([key, cart]) => key && key !== "null" && key !== "undefined" && Object.keys(cart || {}).length > 0)
    .map(([key, cart]) => ({ key, items: Object.values(cart) }));

/** Lines across every cart in the store's state. Pure. */
export const cartLineCount = (state) =>
  (Array.isArray(state?.cart?.products) ? state.cart.products.length : 0) +
  VENDOR_CART_SLICES.reduce(
    (count, slice) =>
      count + filledVendorCarts(state?.[slice]?.carts).reduce((lines, cart) => lines + cart.items.length, 0),
    0
  );

/** The header badge's number. */
export const useCartCount = () => useSelector(cartLineCount);
